import { connect } from 'react-redux';

import AcceptInvitationView from '../components/AcceptInvitationView';

const mapActionCreators = {};

const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(AcceptInvitationView);
